// Crash catcher (2026-07-27): "starting an RP keeps making my app crash" was
// unreproducible on desktop — the iOS webview dies without leaving a trace we
// can read. This turns every uncaught error, unhandled rejection, and React
// boundary catch into a row in client_errors, so the next crash on ANY device
// hands us the actual message + stack + build.
import { supabase } from './supabaseClient.js';

const seen = new Set();

// Pure gate, unit-tested: max N distinct errors per session, dedupe by key,
// and skip the noise classes that aren't app bugs.
export function shouldReport(key, seenSet = seen, max = 6) {
  if (!key) return false;
  const k = String(key).slice(0, 200);
  if (/ResizeObserver|Script error\.$|Load failed|NetworkError|Failed to fetch|AbortError/i.test(k)) return false;
  if (seenSet.has(k)) return false;
  if (seenSet.size >= max) return false;
  seenSet.add(k);
  return true;
}

export function logClientError(context, err, extra = '') {
  try {
    const message = String(err?.message || err || 'unknown').slice(0, 500);
    if (!shouldReport(`${context}:${message}`)) return;
    const stack = String(err?.stack || extra || '').slice(0, 4000);
    supabase.from('client_errors').insert({
      context: String(context || 'unknown').slice(0, 60),
      message,
      stack,
      build: (typeof window !== 'undefined' && window.__MFML_BUILD__) || '',
      ua: (typeof navigator !== 'undefined' && navigator.userAgent || '').slice(0, 300),
    }).then(null, () => {});
  } catch { /* the crash catcher must never crash */ }
}

export function initCrashCatcher(buildVersion) {
  try {
    if (typeof window === 'undefined' || window.__mfmlCrashCatcher) return;
    window.__mfmlCrashCatcher = true;
    window.__MFML_BUILD__ = buildVersion;
    window.addEventListener('error', (e) => {
      logClientError('window_error', e?.error || e?.message, e?.filename ? `${e.filename}:${e.lineno}` : '');
    });
    window.addEventListener('unhandledrejection', (e) => {
      logClientError('unhandled_rejection', e?.reason);
    });
  } catch { /* never crash */ }
}
